import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { MortgageCampaignSaroutycreditsimulatorTemplatePropsInterface } from 'common/module/mortgage/campaign/saroutycreditsimulator/template-props.interface';

export const MortgageCampaignSaroutycreditsimulatorTemplate: FunctionalComponent<MortgageCampaignSaroutycreditsimulatorTemplatePropsInterface> =
  (props) => {
    return (
      <div className='saroutycreditsimulator'>
        <div className='saroutycreditsimulator__header'>
          <div className='saroutycreditsimulator__header-txt'>{i18nTranslate('Simulateur de crédit Sarouty')}</div>
          <span
            className='svg'
            dangerouslySetInnerHTML={{
              __html: `
            <svg viewBox='0 0 480 448' class='saroutycreditsimulator__header-img'>
              <use xlink:href='#svg-cogs'></use>
            </svg>
          `,
            }}
          />
        </div>
        <div className='saroutycreditsimulator__content'>
          <img className='saroutycreditsimulator__logo' src={__('assets/common/sarouty-credit-simulator-logo.svg')} />
          <a
            href={props.buttonUrl}
            target='_blank'
            className='button saroutycreditsimulator__button'
            onClick={() => props.onClick()}
            rel='noreferrer'
          >
            {i18nTranslate('Calculate')}
          </a>
        </div>
      </div>
    );
  };
